export default "__VITE_ASSET__12a493b4__"